// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__Hzjsd","tooltipText":"Tooltip_tooltipText__SS7en","tooltipTextDown":"Tooltip_tooltipTextDown__tsHtM","centerMobile":"Tooltip_centerMobile__QAULO"};